module.exports = __webpack_public_path__ + "static/media/delete.78c7534a.svg";